import { BusinessContextModel } from '../../core/model/BusinessContext.model';
import { L3ServicesHttpQuery } from './L3ServicesQuery.config';

export const L3ServicesBusinessContextConfig: BusinessContextModel = {
  translateNamespace: 'l3Services',
  queries: L3ServicesHttpQuery,
};
